import Vue from 'vue';
import Router, { NavigationGuard } from 'vue-router';
import BookBuilder from '@/ui/BookBuilder.vue';
import { globalState } from '@/container';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: BookBuilder,
        },
    ],
});

let verifiedSessionAlive = false;

const authGuard: NavigationGuard = (to, from, next) => {
    if (!verifiedSessionAlive) {
        globalState.userObservable.subscribe((resource) => {
            if (resource.isSuccess) {
                if (resource.data !== null) {
                    verifiedSessionAlive = true;
                    next();
                } else {
                    globalState.beginLogin();
                }
            }
        });
    } else {
        next();
    }
};

router.beforeEach(authGuard);

export default router;
